/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	status: z.string(),
	metaAdSetId: z.string(),
	updatedAt: z.iso.datetime(),
})

export type MetaAdDataSchema = z.infer<typeof metaAdDataSchema>
